let jsonData = {
  DeliveryAddress: {
    contact_name: "",
    delivery_customer_name: "",
    delivery_email: "",
    delivery_address1: "",
    delivery_address2: "",
    delivery_address3: "",
    delivery_address4: "",
    delivery_city: "",
    delivery_country: "",
    delivery_country_code: "",
    delivery_post_code: "",
    shipToID: 0,
  },
  InvoiceAddress: {
    customer_id: "",
    customer_name: "",
    customer_address1: "",
    customer_address2: "",
    customer_address3: "",
    customer_address4: "",
    customer_city: "",
    customer_country: "",
    customer_country_code: "",
    customer_post_code: "",
  },
  Order: [],
};
export default jsonData;
